<template>
  <Dialog ref="dialog" @closed="handleClosed">
    <div class="message-dialoa-content">
      <div>
        <p>{{ message }}</p>
        <p v-if="reason" class="my-2">禁言原因：{{ reason }}</p>
        <p v-if="expire_time">禁言到期时间：{{ time }}</p>
      </div>
    </div>
    <div slot="footer" class="w-[100%]">
      <PrimaryButton @click="handleDiaFooterClick">我知道了</PrimaryButton>
    </div>
  </Dialog>
</template>
<script>
import Dialog from "@/components/Dialog";
import PrimaryButton from "@/components/PrimaryButton";
import dayjs from "dayjs";
export default {
  name: "MessageDialog",
  components:{
    Dialog,
    PrimaryButton
  },
  data(){
     return {
       message:"'",
       reason:"",
       expire_time:"",
       promiseResolve:null
     }
  },
  computed:{
     time(){
       return dayjs.unix(this.expire_time).format('YYYY-MM-DD HH:mm:ss')
     }
  },
  methods:{
    handleDiaFooterClick(){
      this.$refs.dialog.close();
    },
    open(data){
        this.message = data?.message ?? data;
        this.reason = data.reason;
        this.expire_time = data.expire_time
        this.$refs.dialog.open();
        return  new Promise((resolve, reject)=>{
             this.promiseResolve = resolve;
        })
    },
    handleClosed(){
      if(this.promiseResolve){
        this.promiseResolve()
      }
    },
    close(){
      this.$refs.dialog.close();
    }
  }
}
</script>

<style>
  .message-dialoa-content{
    color:  #646464;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    flex-direction: column;
    min-height: 130px;
    justify-content: center;
    align-items: center;
  }
</style>
